
<div (window:resize)="onResize($event)">
<app-public-header></app-public-header>
<app-public-nav></app-public-nav>
<router-outlet></router-outlet>
<div class="sidenav-overlay d-none" id="sidenav-overlay" (click)="rightbar($event)"></div>
</div>

